import { useNavigate } from 'react-router-dom';
import { Screen } from '../../app/Frame';
import { useMeContext } from '../../app/MeContext';
import { useScreen } from '../../app/shell-context';
import { ClockIcon, MessageIcon, SealIcon } from '../../ui/icons';
import { useOnboarding } from '../OnboardingContext';

/** Заявка отправлена: дальше отвечает центр. */
export function Sent() {
  const me = useMeContext();
  const navigate = useNavigate();
  const { nb, reset } = useOnboarding();

  useScreen('Готово', {
    label: 'Понятно',
    onClick: () => {
      reset();
      navigate('/', { replace: true });
    },
  });

  const contact = [me.center.adminContact, me.center.phone].filter(Boolean).join(' или ');

  return (
    <Screen className="success">
      <div className="seal"><SealIcon /></div>
      <h2>Заявка отправлена</h2>
      <p>
        {nb.sentToName
          ? `Заявка ушла администратору и специалисту — ${nb.sentToName}. Ответит тот, кто освободится раньше`
          : 'Заявка ушла администратору организации'}
      </p>
      <div className="card" style={{ width: '100%', textAlign: 'left', marginTop: 6 }}>
        <ul className="meta">
          <li>
            <span className="ico"><ClockIcon /></span>
            <span>
              Ответ обычно в течение дня. Как только специалист закреплён — запись откроется здесь
            </span>
          </li>
          <li>
            <span className="ico"><MessageIcon /></span>
            <span>Вопросы — администратору: {contact}</span>
          </li>
        </ul>
      </div>
    </Screen>
  );
}
